<template>
  <!--**********************************
          Main wrapper start
      ***********************************-->
  <div id="main-wrapper">
    <!--**********************************
    Content body start
***********************************-->

    <div class="content-body pt-0">
      <div class="container-fluid">
        <div class="form-head mb-sm-5 mb-3 d-flex flex-wrap align-items-center pt-3">
          <h2 class="font-w600 title mb-2 mr-auto">{{ lan.partners[3].commission[0].Commissions_new }}</h2>
        </div>

        <div class="lds-ellipsis" v-show="value">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div
          v-if="!value && !newCommissionToReport.length && !upComingCommissions.length && !submittedCommissions.length"
          class="row">
          <span class="col-md-6">
            {{ lan?.commission_blank_page_message }}
          </span>
        </div>

        <div class="row mb-5">
          <div v-if="!value && newCommissionToReport.length" class="col-xl-12">
            <div class="card">
              <div class="card-header border-0 pb-0">
                <h4 class="mb-0 fs-20 text-black">{{ lan.partners[3].commission[0].New_commission_to_report }}</h4>
              </div>
              <div class="card-body tab-content">
                <div class="tab-pane active show fade" id="monthly">
                  <div class="table-responsive">
                    <table class="text-center bg-info-hover tr-rounded order-tbl table-new">
                      <thead>
                        <tr>
                          <th>{{ lan.partners[3].commission[0].Opportunity_new }}</th>
                          <th>{{ lan.partners[3].commission[0].Accounts_new }}</th>
                          <th>{{ lan.partners[3].commission[0].date_new }}</th>
                          <th>{{ lan.partners[3].commission[0].Report_status_Commission_new }}</th>
                        </tr>
                      </thead>
                      <tbody v-for="(data, index) in newCommissionToReport" :key="index"
                        @click="edit(data.commission_id)" class="pointer">
                        <tr class>
                          <td v-if="
                            data.customer_account_detail != ''">
                            {{ data.customer_account_detail[0].name }}
                          </td>
                          <td v-else>
                          </td>
                          <td>{{ data.account_detail.name }}</td>
                          <td>{{ data?.reschedule_date ? data?.reschedule_date : data?.conference_end_date }}</td>
                          <!-- <td v-if="data.commission_status == 'Submitted'">
                            <span class="badge light badge-success"
                              >{{ data.commission_status}}</span
                            >
                          </td> -->
                          <td>
                            <span class="badge light badge-info">{{ data.commission_status == "New" ?
                              lan.admin[7].Commission[0].New_new : data.commission_status == "Submitted" ?
                                lan.admin[7].Commission[0].Submitted_new : data.commission_status }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="lds-ellipsis" v-show="value">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="!value && upComingCommissions.length" class="col-xl-12">
            <div class="card">
              <div class="card-header border-0 pb-0">
                <h4 class="mb-0 fs-20 text-black">{{ lan.partners[3].commission[0].Upcoming_Commission }}</h4>
              </div>
              <div class="card-body tab-content">
                <div class="tab-pane active show fade" id="monthly">
                  <div class="table-responsive">
                    <table class="text-center bg-info-hover tr-rounded order-tbl table-upcoming">
                      <thead>
                        <tr>
                          <th>{{ lan.partners[3].commission[0].Opportunity }}</th>
                          <th>{{ lan.partners[3].commission[0].Accounts }}</th>
                          <th>{{ lan.partners[3].commission[0].date }}</th>
                          <th>{{ lan.partners[3].commission[0].Report_status_Commission }}</th>
                        </tr>
                      </thead>
                      <tbody v-for="(data, index) in upComingCommissions" :key="index" @click="edit(data.commission_id)"
                        class="pointer">
                        <tr>
                          <td v-if="
                            data.customer_account_detail != ''">
                            {{ data.customer_account_detail[0].name }}
                          </td>
                          <td v-else></td>
                          <td>{{ data.account_detail.name }}</td>
                          <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                          <td>
                            <span class="badge light badge-warning">{{ data.commission_status }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="lds-ellipsis" v-show="value">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!value && submittedCommissions.length" class="col-xl-12">
            <div class="card">
              <div class="card-header border-0 pb-0">
                <h4 class="mb-0 fs-20 text-black">{{ lan.partners[3].commission[0].Submitted_commissions }}</h4>
              </div>
              <div class="card-body tab-content">
                <div class="tab-pane active show fade" id="monthly">
                  <div class="table-responsive">
                    <table class="text-center bg-info-hover tr-rounded order-tbl table-submitted">
                      <thead>
                        <tr>
                          <th>{{ lan.partners[3].commission[0].Opportunity }}</th>
                          <th>{{ lan.partners[3].commission[0].Accounts }}</th>
                          <th>{{ lan.partners[3].commission[0].date }}</th>
                          <th>{{ lan.partners[3].commission[0].Report_status_Commission }}</th>
                        </tr>
                      </thead>
                      <tbody v-for="(data, index) in submittedCommissions" :key="index"
                        @click="edit(data.commission_id)" class="pointer">
                        <tr v-if="data.commission_status == 'Submitted'">
                          <td v-if="
                            data.customer_account_detail != ''">
                            {{ data.customer_account_detail[0].name }}
                          </td>
                          <td v-else>
                          </td>
                          <td>{{ data.account_detail.name }}</td>
                          <td>{{ data?.reschedule_date ? data?.reschedule_date : data.conference_end_date }}</td>
                          <!-- <td v-if="data.commission_status == 'Submitted'">
                            <span class="badge light badge-success"
                              >{{ data.commission_status}}</span
                            >
                          </td> -->
                          <td>
                            <span class="badge light badge-info">{{ data.commission_status === "Submitted" ?
                              lan.admin[7].Commission[0].Submitted_new : data.commission_status }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-12">
            <div class="card">
              <div class="card-header border-0 pb-0">
                <h4 class="mb-0 fs-20 text-black">{{ lan.partners[3].commission[0].Received_Commission}}</h4>
              </div>
              <div class="card-body tab-content">
                <div class="tab-pane active show fade" id="monthly">
                  <div class="table-responsive">
                    <table
                      class="text-center bg-info-hover tr-rounded order-tbl"
                    >
                      <thead>
                        <tr>
                          <th>{{ lan.partners[3].commission[0].Opportunity}}</th>
                          <th>{{ lan.partners[3].commission[0].Accounts}}</th>
                          <th>{{ lan.partners[3].commission[0].date}}</th>
                          <th>{{ lan.partners[3].commission[0].Report_status_Commission}}</th>
                        </tr>
                      </thead>
                      <tbody v-for="(data, index) in commissionDetails"
                          :key="index"
                          @click="edit(data.commission_id)"
                          class="pointer">
                        <tr
                          v-if="data.commission_status == 'Submitted'"
                        >
                          <td v-if="
                            data.customer_account_detail != ''">
                            {{ data.customer_account_detail[0].name }}
                          </td>
                          <td v-else>
                          </td>
                          <td>{{ data.account_detail.name }}</td>
                          <td>{{ data.conference_end_date }}</td>
                          <td v-if="data.commission_status == 'Submitted'">
                            <span class="badge light badge-success"
                              >{{ data.commission_status}}</span
                            >
                          </td>
                          <td v-else>
                            <span class="badge light badge-info"
                              >{{ data.commission_status}}</span
                            >
                          </td>
                        </tr>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

        </div>
        <div class="col-xl-6 col-xxl-12">
          <div class="row"></div>
        </div>
      </div>
    </div>
    <!--**********************************
    Content body end
***********************************-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Partner Commission",
  data() {
    return {
      commissionDetails: "",
      value: true,
      newCommissionToReport: [],
      upComingCommissions: [],
      submittedCommissions: []
    };
  },

  computed: {
    lan() {
      return this.$store.getters.whichLanguage
    }
  },


  // created() {
  //   this.$store.dispatch("tryAutoLogin");
  //   if (!this.$store.getters.isPartner) {
  //     this.AddToast("You can't access Partner Portal", " Warning ", "warning_1");
  //     setTimeout(() => {
  //       alert('First logout then Login partner portal.')
  //     this.$router.back()
  //     }, 3000);
  //   }
  // },
  mounted() {
    // for top load page
    window.scrollTo(0, 0);

    const user = JSON.parse(localStorage.getItem("user"));
    axios
      .get(axios.defaults.baseURL + "get-commissions/" + user.company, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.value = false;
        this.commissionDetails = res.data.data;

        // newCommissionToReport and upComingCommissions data start
        for (let i = 0; i < this.commissionDetails.length; i++) {
          let today = new Date();
          let commission = this.commissionDetails[i];
          if (commission.commission_status === 'Invoiced') continue;
          let endDate = new Date(commission.conference_end_date);
          let reschedule_date = new Date(commission.reschedule_date);
          console.log("reschedule_date---", typeof reschedule_date);
          if (reschedule_date) {
            console.log("reschedule_date--yes-", reschedule_date);
          }

          if (endDate < today) {
            // Add the commission to the newCommissionToReport array
            this.newCommissionToReport.push(commission);
          }
          else if (commission.commission_status == 'Submitted') {
            this.submittedCommissions.push(commission)
          }
          else if (endDate > today) {
            this.upComingCommissions.push(commission)
          }
        }

          this.sortByDateDesc(this.newCommissionToReport);
          this.sortByDateAsc(this.upComingCommissions);
          this.sortByDateDesc(this.submittedCommissions);
        })
        .catch((err) => {
          this.value = false;
          this.$store.dispatch("checkErrorAndSendToast", [
            err.response,
            "error",
          ]);
        });


  },
  methods: {
    edit(id) {
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Partner Edit Commission", params: { id: id }, });
    },
    AddToast(message, title, type) {
      this.$store.commit("addToast", {
        title: title,
        type: type,
        message: message,
      });
      setTimeout(() => {
        this.dismissToast(title);
      }, 5000);
    },
    dismissToast(title) {
      this.$store.commit("clearToast", title);
    },
    sortByDateAsc(list) {
      const getDate = (item) => {
        const d = item.reschedule_date ? new Date(item.reschedule_date) : new Date(item.conference_end_date);
        return Number.isNaN(d.getTime()) ? new Date(0) : d;
      };
      list.sort((a, b) => getDate(a) - getDate(b));
    },
    sortByDateDesc(list) {
      const getDate = (item) => {
        const d = item.reschedule_date ? new Date(item.reschedule_date) : new Date(item.conference_end_date);
        return Number.isNaN(d.getTime()) ? new Date(0) : d;
      };
      list.sort((a, b) => getDate(b) - getDate(a  ));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-new thead {
  background: rgba(40, 167, 69, 0.14);
}
.table-new tbody tr:hover {
  background: rgba(40, 167, 69, 0.08);
}

.table-upcoming thead {
  background: rgba(23, 162, 184, 0.14);
}
.table-upcoming tbody tr:hover {
  background: rgba(23, 162, 184, 0.1);
}

.table-submitted thead {
  background: rgba(108, 117, 125, 0.14);
}
.table-submitted tbody tr:hover {
  background: rgba(108, 117, 125, 0.1);
}

.table-new,
.table-upcoming,
.table-submitted {
  width: 100%;
  table-layout: fixed;
}

.table-new th,
.table-new td,
.table-upcoming th,
.table-upcoming td,
.table-submitted th,
.table-submitted td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-new th:nth-child(1),
.table-new td:nth-child(1),
.table-upcoming th:nth-child(1),
.table-upcoming td:nth-child(1),
.table-submitted th:nth-child(1),
.table-submitted td:nth-child(1) {
  width: 35%;
}

.table-new th:nth-child(2),
.table-new td:nth-child(2),
.table-upcoming th:nth-child(2),
.table-upcoming td:nth-child(2),
.table-submitted th:nth-child(2),
.table-submitted td:nth-child(2) {
  width: 25%;
}

.table-new th:nth-child(3),
.table-new td:nth-child(3),
.table-upcoming th:nth-child(3),
.table-upcoming td:nth-child(3),
.table-submitted th:nth-child(3),
.table-submitted td:nth-child(3) {
  width: 20%;
}

.table-new th:nth-child(4),
.table-new td:nth-child(4),
.table-upcoming th:nth-child(4),
.table-upcoming td:nth-child(4),
.table-submitted th:nth-child(4),
.table-submitted td:nth-child(4) {
  width: 20%;
}
</style>
